<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="container-fluid pl-0">
  <div class="container-inner">
    <div>
      <div class="report-container">
        <h2 style="font-size: 18px;">Reports</h2>
  
        <div class="action-container">
          <ng-container>
            <span  style="font-weight: 500;">All Outlets</span>
            <label class="switch mt-2">
              <input type="checkbox" [(ngModel)]="isActiveOutlet" (click)="outletToggle($event.target)">
              <span class="slider-outlet"></span>
            </label>
            <span class="mr-1" style="font-weight: 500;">Hyperlocal Outlets</span>
          </ng-container>
          <div class="dropdown-container" style="width: 280px;">
            <select name="" class="form-select" [(ngModel)]="selectedReportId" [ngModelOptions]="{standalone: true}">
              <option value="" disabled selected>--Select Report--</option>
              <option [value]="data.id" *ngFor="let data of reportsMaster">{{data.name}}</option>
            </select>
          </div>
          <div class="date-range">
            <input type="text" placeholder="Select Date Range" class="form-control" 
              [bsConfig]="{containerClass:'theme-dark-blue', rangeInputFormat : 'DD/MM/YYYY', dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false, maxDate: today }"
              [(ngModel)]="dateRange" bsDaterangepicker
              >
          </div>
          
          <button mat-raised-button class="add-button" (click)="getReport()">Generate Report</button>
        </div>
      </div>
      <div class="header-container">
        <div class="leads-table mb-3">
          <table mat-table [dataSource]="dataSource" matSort class="mat-table">
            <ng-container matColumnDef="SNo">
              <th mat-header-cell *matHeaderCellDef> S.No </th>
              <td mat-cell *matCellDef="let element; let i = index"> {{ (paginatorRef.pageIndex *
                paginatorRef.pageSize) + (i + 1) }}</td>
            </ng-container>

            <ng-container matColumnDef="start_date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Range</th>
              <td mat-cell *matCellDef="let element">
                {{ element.start_date | date: 'dd/MM/yyyy' }} - {{ element.end_date | date: 'dd/MM/yyyy' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="report">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Report Name</th>
              <td mat-cell *matCellDef="let element">{{element.report}}</td>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef style="text-align: center;">Download</th>
              <td mat-cell *matCellDef="let element" style="text-align: center;">
                <a [href]="element.download_url" download>
                  <img src="assets/images/graph-download.png" class="edit-pen" title="Download">
                </a>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" style="text-align: center;padding: 20px 0;" colspan="4">No data found!
              </td>
            </tr>
          </table>

          <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </div>
  </div>